export const VERSION = "0.37.2"
export const WASM_WNFS_VERSION = "0.1.7"
